// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2g-0";
export var spinnerContainer = "_2g-1";